namespace Solovis.Reports {

    export class ReportStackEngine {

        public reportStack;

        constructor(options) {
            this.reportStack = options.reportStack;
        }


        /**
         * 
         * @param parameterMappingList - parameterMappingList is a list of mappings to apply to parameters
         * @param sourceValues - sourceValues are from the parent container.
         * @param targetValues - targetValues is target to write new values into.
         * @param currentValues - currentValues would be the previous set of values used for the target report.
         */
        public static applyParameterMappings(parameterMappingList, sourceValues, targetValues, currentValues?) {     
            var newTargetValues = {};

            var getParamValueForTransform = function (paramName) {
                // Retrieve parameter value at certain point in time, so we can have dependent parameter values.
                var currentParamValue = newTargetValues[paramName];
                if (typeof currentParamValue != "undefined") {
                    return currentParamValue;
                }

                return null;
            };

            var getSourceParamValueForTransform = function (paramName) {
                var sourceParamValue = sourceValues[paramName];
                if (typeof sourceParamValue != "undefined") {
                    return sourceParamValue;
                }

                return null;
            };

            var getPriorParamValueForTransform = function (paramName) {
                if (currentValues) {
                    var oldParamValue = currentValues[paramName];
                    if (typeof oldParamValue != "undefined") {
                        return oldParamValue;
                    }
                }

                return null;
            };

            // Need to order parameter mappings according to any dependencies that might be present.
            var reorderedParameterMappingList = ReportStackEngine._reorderParameterMappingsByDependencies(parameterMappingList);

            $(reorderedParameterMappingList).each(function (i, mapping: any) {
                var paramValue = sourceValues[mapping.source];

                // Apply any transforms.
                if (mapping.transform) {
                    var newParamValue = Solovis.Reports.Parameters.ParameterTransforms.transform(
                        paramValue,
                        {
                            transform: mapping.transform,
                            parameterValueGetter: getParamValueForTransform,
                            sourceParameterValueGetter: getSourceParamValueForTransform,
                            priorParameterValueGetter: getPriorParamValueForTransform
                        });
                    paramValue = newParamValue;
                }

                var currentTargetValue = null;
                if (typeof newTargetValues[mapping.target] !== 'undefined') {                    
                    currentTargetValue = newTargetValues[mapping.target];
                }

                var newValue = null;
                if (Solovis.isNotNull(currentTargetValue)) {
                    if (Solovis.isNull(currentTargetValue.length)) {
                        newValue = [currentTargetValue];
                    }
                    else if (currentTargetValue.length !== 0) {
                        // currentTargetValue is assumed to be an array.
                        newValue = [].concat(currentTargetValue);
                    }
                    else {
                        newValue = [];
                    }

                    // Now, we need to add the additional paramValue to newValue array.
                    if (Solovis.isNotNull(paramValue)) {
                        if (Solovis.isNull(paramValue.length)) {
                            newValue.push(paramValue);
                        }
                        else if (paramValue.length !== 0) {
                            // paramValue is assumed to be an array.
                            newValue = newValue.concat(paramValue);
                        }
                    }
                }
                else {
                    newValue = paramValue;
                }

                newTargetValues[mapping.target] = newValue;
            });

            var changeCount = 0;
            for (var paramName in newTargetValues) {
                targetValues[paramName] = newTargetValues[paramName];
                changeCount++;
            }

            return changeCount;
        }


        public static _reorderParameterMappingsByDependencies(parameterMappingList) {
            if (!parameterMappingList) {
                return null;
            }

            var paramOptionList = [];
            var paramOptionMap = {};

            $(parameterMappingList).each(function (i, paramMapping: any) {
                var optionEntry: any = {
                    paramMapping: paramMapping
                };

                var dependencies: any = {};

                if (paramMapping.transform) {
                    var trasformDependencies = Solovis.Reports.Parameters.ParameterTransforms.findParameterDependencies(paramMapping.transform);
                    $(trasformDependencies).each(function (k, dependencyName: any) {
                        dependencies[dependencyName] = true;
                    });
                }

                optionEntry.dependencies = dependencies;

                paramOptionMap[paramMapping.target] = optionEntry;
                paramOptionList.push(optionEntry);
            });

            // Will keep track of parameters added to newOrderedList.
            var parametersUsedMap = {};

            // The newly ordered list of parameters based on dependencies.
            var newOrderedList = [];

            var placeItemsInNewOrderedList = function () {
                $(paramOptionList).each(function (i, optionEntry: any) {
                    var paramName = optionEntry.paramMapping.target;

                    // If the parameter hasn't been added yet...
                    if (!parametersUsedMap[paramName]) {
                        // If all dependencies are present, we can add it.    
                        var missingDependencyFound = false;
                        for (var dependencyName in optionEntry.dependencies) {
                            // If there is a dependency on a parameter without a mapping, we don't need
                            // the dependency link because we will used the fixed value.
                            var hasParamMapping = paramOptionMap[dependencyName] ? true : false;

                            if (hasParamMapping && !parametersUsedMap[dependencyName]) {
                                missingDependencyFound = true;
                            }
                        }

                        if (!missingDependencyFound) {
                            newOrderedList.push(optionEntry.paramMapping);
                            parametersUsedMap[paramName] = true;
                        }
                    }
                });
            };

            var lastCount = 0;
            for (; ;) {
                placeItemsInNewOrderedList();

                var newCount = newOrderedList.length;
                if (newCount >= parameterMappingList.length) {
                    break;
                }
                else if (lastCount == newCount) {
                    throw "Circular dependency must exist among parameters.";
                }

                lastCount = newCount;
            }

            return newOrderedList;
        };


        public _getBlockElementName(blockDefinition) {
            var elementName = blockDefinition.elementName ?
                blockDefinition.elementName
                :
                "Block_" + kendo.toString(new Date(), "yyyyMMdd_HHmmss_fff") + _.uniqueId("_");

            return elementName;
        }

        public _createReportBlock(reportBlockDefinition) {
            var self = this;

            var reportCode = reportBlockDefinition.report.code;

            var parameterMap = null;
            if (reportBlockDefinition.parameterMappings) {
                parameterMap = function (parameters) {
                    var params = {};

                    // TODO: See if we can get the current values for the sub-report.                

                    ReportStackEngine.applyParameterMappings(reportBlockDefinition.parameterMappings, parameters, params);

                    return params;
                };
            }

            var elementName = this._getBlockElementName(reportBlockDefinition);

            var wrapWithBlockWithHeader = false;
            if (reportBlockDefinition.style && reportBlockDefinition.style.showAsBlockWithHeader) {
                wrapWithBlockWithHeader = true;
            }


            var shouldAutoRun = true;
            var shouldAutoRunOnParameterChange = false;
            var shouldCollapseConfigSection = true;
            var shouldShowConfigSectionInline = true;
            var shouldHideRunButton = false;
            var isWidget = Solovis.isNotNull(reportBlockDefinition.widgetCode);

            if (reportBlockDefinition.blockOptions) {
                var blockOptions = reportBlockDefinition.blockOptions;

                if (Solovis.isNotNull(blockOptions.autoRun)) {
                    shouldAutoRun = blockOptions.autoRun;
                }

                if (Solovis.isNotNull(blockOptions.autoRunOnParameterChange)) {
                    shouldAutoRunOnParameterChange = blockOptions.autoRunOnParameterChange;
                }

                if (Solovis.isNotNull(blockOptions.collapseConfigSection)) {
                    shouldCollapseConfigSection = blockOptions.collapseConfigSection;
                }

                if (Solovis.isNotNull(blockOptions.showConfigSectionInline)) {
                    shouldShowConfigSectionInline = blockOptions.showConfigSectionInline;
                }

                if (Solovis.isNotNull(blockOptions.hideRunButton)) {
                    shouldHideRunButton = blockOptions.hideRunButton;
                }
            }

            var reportSettings = reportBlockDefinition.reportSettings ? reportBlockDefinition.reportSettings : {};

            var block: any = {
                elementName: elementName,
                partControl: "Solovis.Reports.Parts.SubReportControl",

                settings: {
                    usePersistedSettings: true,
                    reportOptions: function () {

                        var targetParameters = null;
                        if (parameterMap) {
                            targetParameters = parameterMap(this.parameters);
                        }
                        else {
                            targetParameters = {};
                        }

                        var options: any = {
                            reportCode: reportCode,

                            parameters: targetParameters,

                            autoRun: shouldAutoRun,
                            autoRunOnParameterChange: shouldAutoRunOnParameterChange,
                            collapseConfigSection: shouldCollapseConfigSection,
                            showConfigSectionInline: shouldShowConfigSectionInline,
                            hideRunButton: shouldHideRunButton,
                        };

                        if (isWidget) {
                            options.widgetCode = reportBlockDefinition.widgetCode;
                            options.widgetTitle = reportBlockDefinition.elementName;
                        }

                        if (wrapWithBlockWithHeader) {
                            // Report options will be shown in block header instead.
                            options.hideReportOptionsButton = true;
                        }

                        if (reportSettings.initialValueOverrides) {
                            options.initialValueOverrides = reportSettings.initialValueOverrides;
                        }

                        if (reportSettings.persistedSettings) {
                            options.defaultPersistedSettings = reportSettings.persistedSettings;
                        }

                        if (blockOptions.reportContentHeight) {
                            options.contentHeight = parseInt(blockOptions.reportContentHeight);
                        }

                        if (reportBlockDefinition.cacheSettings) {
                            var cachePolicy: any = {};
                            if (reportBlockDefinition.cacheSettings.includeCacheSummaryHeader) {
                                cachePolicy.includeCacheSummaryHeader = true;
                            }
                            if (reportBlockDefinition.cacheSettings.cacheForNMinutes) {
                                var cacheForNMinutes = parseFloat(reportBlockDefinition.cacheSettings.cacheForNMinutes);
                                var millisecondsPerMinute = 1000 * 60;

                                if (cacheForNMinutes) {
                                    cachePolicy.caching = function () {
                                        var cacheInfo: any = {};
                                        cacheInfo.allowCaching = true;
                                        cacheInfo.expireCachingAt = new Date().getTime() + (cacheForNMinutes * millisecondsPerMinute);
                                        cacheInfo.allowCachedResponse = true;
                                        cacheInfo.oldestDataAllowedFrom = new Date().getTime() - (cacheForNMinutes * millisecondsPerMinute);
                                        return cacheInfo;
                                    };
                                }
                            }

                            options.cachePolicy = cachePolicy;
                        }

                        return options;
                    }
                }


            };

            

            this._applyStyleToBlock(block, reportBlockDefinition.style);

            if (wrapWithBlockWithHeader) {
                var blockWithHeader = {
                    layout: "BlockWithHeader",

                    style: {
                        width: "100%"
                    },

                    header: {
                        partControl: "Solovis.Reports.Parts.SubReportBlockHeaderControl",
                        settings: {
                            subReportElementName: elementName
                        }
                    },

                    content: block,

                    noPaddingOnContent: true
                };

                block = blockWithHeader;
            }

            return block;
        }

        public _createHtmlBlock(blockDefinition) {
            var blockElementName = blockDefinition.elementName ? blockDefinition.elementName : null;

            var block = {
                elementName: blockElementName,
                partControl: "Solovis.Reports.Parts.HtmlControl",
                settings: {
                    html: blockDefinition.html,
                    cleanHtml: true
                }
            };

            this._applyStyleToBlock(block, blockDefinition.style);

            return block;
        }        


        public _createTableCopyBlock(blockDefinition) {
            var blockElementName = blockDefinition.elementName ? blockDefinition.elementName : null;
            let tableCopyOptions = blockDefinition.tableCopy;

            // NOTES:
            //   ReportControl fires reportDataLoaded when all data is loaded.
            //   SubReportControl fires subReportControlChanged when a sub-report is changed out.

            let watchForReferencedSubReport = function (referenceReportControl: Solovis.Reports.ReportControl, reportPartName, callback) {          
                let lastSubReportControl = null;

                let tryNotifySubReportControl = function () {                    
                    let newSubReportControl = subReportPartControl.subReportControl;
                    if (newSubReportControl !== lastSubReportControl) {
                        lastSubReportControl = newSubReportControl;
                        callback(newSubReportControl);
                    }
                };

                let subReportPartControl = referenceReportControl.getReportPartControl(reportPartName);
                $(subReportPartControl).bind("subReportControlChanged", function () {
                    tryNotifySubReportControl();
                });

                if (subReportPartControl.subReportControl) {
                    tryNotifySubReportControl();
                }
            };

            let watchForTablePartWithData = function (referenceReportControl: Solovis.Reports.ReportControl, reportPartName, tablePartName, callback) {

                let lastSubReportControl = null;
                let lastRunCount = 0;

                watchForReferencedSubReport(referenceReportControl, reportPartName, function (subReportControl: Solovis.Reports.ReportControl) {
                    let findTablePart = function () {
                        if (tablePartName) {
                            let tablePart = subReportControl.getReportPartControl(tablePartName);
                            return tablePart;
                        }                        
                    };

                    let checkForData = function () {
                        let tablePart = findTablePart();
                        if (tablePart) {
                            var newRunCount = subReportControl.runCount();
                            if (lastSubReportControl !== subReportControl || lastRunCount !== newRunCount) {
                                lastSubReportControl = subReportControl;
                                lastRunCount = newRunCount;
                                callback(tablePart);
                            }
                        }
                    };

                    if (subReportControl.runCount() > 0 && !subReportControl.isRunning()) {
                        checkForData();
                    }

                    $(subReportControl).bind("reportDataLoaded", function () {
                        checkForData();
                    });
                });
            };

            let setupTableCloneReportOptions = function (tablePartToCopy) {
                let settingsCopy: any = {};
                for (var propName in tablePartToCopy.settings) {
                    if (tablePartToCopy.settings.hasOwnProperty(propName)) {
                        settingsCopy[propName] = tablePartToCopy.settings[propName];
                    }
                }

                let modelEnvToUse = Solovis.resolveObject(settingsCopy.modelEnvironment.path, tablePartToCopy.dataSets);
                let rowDataToUse = Solovis.resolveObject(settingsCopy.rowData, tablePartToCopy);

                settingsCopy.modelEnvironment = {
                    path: "otherTable.modelEnvToUse"
                };
                settingsCopy.rowData = "dataSets.otherTable.rowDataToUse";

                let otherTableDataSet = {
                    parameters: tablePartToCopy.parameters,
                    settingsCopy: settingsCopy,
                    modelEnvToUse: modelEnvToUse,
                    rowDataToUse: rowDataToUse,
                    tablePartToCopy: tablePartToCopy
                };

                let dataSources = [
                    { name: "otherTable", data: otherTableDataSet }
                ];

                for (var dataSetName in tablePartToCopy.dataSets) {
                    dataSources.push({ name: dataSetName, data: tablePartToCopy.dataSets[dataSetName] });
                }


                let reportOptions: any = {
                    report: {
                        parameters: [],

                        root: {
                            elementName: "Root",

                            partControl: "Solovis.Reports.Parts.Tables.DataTableControl",

                            parameterOverrides: tablePartToCopy.parameters,

                            settings: settingsCopy,

                            dataSources: dataSources
                        }
                    },

                    parameters: [],

                    autoRun: true,
                    autoRunOnParameterChange: false,
                    showConfigSectionInline: false,
                    hideRunButton: true,
                    collapseConfigSection: false,
                    hideReportOptionsButton: true
                };

                if (tableCopyOptions.tablePersistedSettings) {
                    reportOptions.defaultPersistedSettings = {
                        Root: tableCopyOptions.tablePersistedSettings
                    };
                }

                return reportOptions;
            };

            var block = {
                elementName: blockElementName,
                partControl: "Solovis.Reports.Parts.HtmlControl",

                settings: {

                    render: function () {                        
                        let self = this;
                        let reportPartName = tableCopyOptions.reportElementName;
                        let tablePartName = tableCopyOptions.tableElementName;

                        let reportElement = $("<div>").appendTo(this.container);
                        let reportControlHost = new Solovis.UI.ControlHost({ container: reportElement });

                        watchForTablePartWithData(this.reportControl, reportPartName, tablePartName, function (tablePart) {                            
                            let reportOptions: any = setupTableCloneReportOptions(tablePart);

                            let persistedSettingsToUse = self.persistedSettings ? self.persistedSettings.tableSettings : null;
                            if (self.tableCloneReport) {
                                persistedSettingsToUse = self.tableCloneReport.collectPersistedSettings();
                            }

                            reportOptions.persistedSettings = persistedSettingsToUse;

                            self.tableCloneReport = new Solovis.Reports.ReportControl(reportOptions);
                            reportControlHost.setCurrentControl(self.tableCloneReport);
                        });
                    },

                    getPersistedSettings: function () {
                        let self = this;

                        if (self.tableCloneReport) {
                            let persistedSettings = {
                                tableSettings: self.tableCloneReport.collectPersistedSettings()
                            };
                            return persistedSettings;
                        }
                        else {
                            return null;
                        }
                    }
                }
            };

            this._applyStyleToBlock(block, blockDefinition.style);

            return block;
        }


        public _createBlock(blockDefinition) {
            var self = this;

            if (typeof blockDefinition.report != "undefined") {
                let block = this._createReportBlock(blockDefinition);
                return block;
            }
            else if (typeof blockDefinition.html != "undefined") {
                let block = this._createHtmlBlock(blockDefinition);
                return block;
            }
            else if (typeof blockDefinition.tableau != "undefined") {
                let block = this._createHtmlBlock({ html: "Tableau blocks not supported." });
                return block;
            }
            else if (typeof blockDefinition.tableCopy != "undefined") {
                let block = this._createTableCopyBlock(blockDefinition);
                return block;
            }
            else if (typeof blockDefinition.layout != "undefined") {
                // layout should be Vertical, Horizontal, or Tabbed.
                if (blockDefinition.layout == "Tabbed") {
                    let block = this._createTabbedLayoutBlock(blockDefinition);
                    return block;
                }
                else {
                    let block: any = {
                        layout: blockDefinition.layout
                    };

                    if (blockDefinition.children) {
                        block.children = [];

                        $(blockDefinition.children).each(function (i, childDefinition) {
                            var child = self._createBlock(childDefinition);
                            block.children.push(child);
                        });
                    }

                    this._applyStyleToBlock(block, blockDefinition.style);

                    return block;
                }
            }
            else {
                throw "Unknown block definition format";
            }
        }

        public _createTabbedLayoutBlock(blockDefinition) {
            var self = this;

            // We will create a sub-report for each tab that contains the needed elements for that tab.
            var parametersForTabReport = null;

            var reportStack = this.reportStack;
            if (reportStack.parameters) {
                parametersForTabReport = Solovis.deepCopy(reportStack.parameters);
            }

            var tabBlockElementName = this._getBlockElementName(blockDefinition);

            var tabBlock = {
                elementName: tabBlockElementName,
                partControl: 'Solovis.Reports.Parts.TabListSubReportControl',

                settings: {
                    tabs: function () {
                        var tabList = [];

                        if (blockDefinition.children) {
                          $(blockDefinition.children).each(function (i, childDefinition: any) {
                                var tabReportStack: any = {};
                                if (reportStack.parameters) {
                                    tabReportStack.parameters = Solovis.deepCopy(reportStack.parameters);
                                }

                                tabReportStack.stackRoot = childDefinition;

                                var tabReportStackEngine = new ReportStackEngine({ reportStack: tabReportStack });
                                var tabReport = tabReportStackEngine.createReportFromReportStack();

                                var tabCode = "Tab_" + self._getBlockElementName(childDefinition);
                                var tabLabel = "Tab " + i;
                                if (childDefinition.blockOptions) {
                                    if (childDefinition.blockOptions.tabLabel) {
                                        tabLabel = childDefinition.blockOptions.tabLabel;
                                    }
                                }

                                var tab = {
                                    code: tabCode,
                                    label: tabLabel,

                                    noPadding: true,
                                    keepTabBetweenRunsIfActive: false,
                                    usePersistedSettings: true,

                                    // clear because graphs will not redraw properly while report is hidden
                                    clearOnTabDeactivate: true,

                                    reportOptions: function () {
                                        var options: any = {};

                                        options.report = tabReport;
                                        options.parameters = this.parameters;

                                        options.showConfigSectionInline = false;
                                        options.autoRun = true;
                                        options.hideReportOptionsButton = true;

                                        return options;
                                    }
                                };

                                tabList.push(tab);
                            });
                        }

                        return tabList;
                    }
                }
            };

            this._applyStyleToBlock(tabBlock, blockDefinition.style);

            return tabBlock;
        }

        public createReportFromReportStack() {
            var report: any = {};

            var reportStack = this.reportStack;

            if (reportStack.parameters) {
                report.parameters = Solovis.deepCopy(reportStack.parameters);

                if (report.parameters) {
                    for (let parameter of report.parameters) {
                        // Force utcTimestamp parameters to use local mode (NOTE: We could consider letting user select the mode).
                        if (parameter.parameterType == "utcTimestamp") {
                            parameter.settings = {
                                utcDisplayMode: "local"
                            };
                        }
                    }
                }
            }

            if (reportStack.stackOptions) {
                report.fullWidth = reportStack.stackOptions.fullWidth;
                report.autoRun = reportStack.stackOptions.autoRun;
                report.autoRunOnParameterChange = reportStack.stackOptions.autoRunOnParameterChange;
                report.collapseConfigSection = reportStack.stackOptions.collapseConfigSection;
                report.showConfigSectionInline = reportStack.stackOptions.showConfigSectionInline;
                report.hideRunButton = reportStack.stackOptions.hideRunButton;
                report.hideReportOptionsButton = reportStack.stackOptions.hideReportOptionsButton;

                if (reportStack.stackOptions.useDescriptionPropertyForHelp) {
                    report.help = {
                        useDescriptionProperty: true
                    };
                }
            }
            else {
                report.fullWidth = true;
            }

            if (reportStack.stackRoot) {
                report.root = this._createBlock(reportStack.stackRoot);
            }

            return report;
        }

        public addChildDefintionToChildList(blockDefinition, childDefinition) {
            if (blockDefinition.children) {
                blockDefinition.children.unshift(childDefinition);
            }
        }

        public _applyStyleToBlock(block, style) {
            if (style) {
                block.style = Solovis.deepCopy(style);
            }
        }
    }

}


    
